// extracted by mini-css-extract-plugin
export var root = "QeBa";
export var rootAddress = "nGPP";
export var rootContact = "U8RO";
export var rootContactLink = "_5sRj";
export var rootContactLinks = "JMqr";
export var rootContactTel = "mYRD";
export var rootLogo = "rxQW";
export var rootSocials = "+WaS";
export var rootSocialsIcon = "D896";
export var rootSocialsIcons = "+Aem";
export var rootSocialsLink = "_4Lj2";